module.exports = __webpack_public_path__ + "static/media/lumio_logo.6b9c94bb.png";